import PropTypes from 'prop-types';
import React, { useState } from 'react';
import WowModal from '../WowModal';
import HeaderIcon from './HeaderIcon';
import MobileMenu from './mobilenav/MobileMenuDynamic';

const HeaderBurgerMenu = ({
  isFindPage = false,
  isLoggedIn,
  navigation,
  path,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [dimensions, setDimensions] = useState({ bottom: 0 });
  const ref = React.createRef();

  const openMenu = (show) => {
    if (ref.current) {
      setDimensions({
        bottom: ref.current.getBoundingClientRect().bottom,
      });
    }
    setShowModal(show);
  };

  const isLoggedInClass = isLoggedIn ? 'is-logged-in' : '';
  const modalExtraClasses = `${isLoggedInClass} slide-out-menu remove-header with-slide-in no-body-padding no-rounded-corners`;

  return (
    <div ref={ref}>
      <WowModal
        ariaLabelledBy="id-burger-menu"
        backdropClassName="remove-backdrop"
        extraClasses={modalExtraClasses}
        setShowModal={setShowModal}
        showModal={showModal}
        size="lg"
        topPosition={dimensions.bottom}
      >
        <MobileMenu
          isFindPage={isFindPage}
          navigation={navigation}
          openMenu={openMenu}
          path={path}
        />
      </WowModal>

      <HeaderIcon
        clickMethod={() => openMenu(true)}
        icon="burger"
        isFirst
        linkId="id-burger-menu"
      />
    </div>
  );
};

export default HeaderBurgerMenu;

HeaderBurgerMenu.propTypes = {
  isFindPage: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  navigation: PropTypes.array,
  path: PropTypes.string,
};
